import { useListSchoolCurriculumsQuery } from '@/types/vue-apollo-helpers';

export function useCurriculum(options?: { autoFetch?: boolean }) {
  const programmeId = ref<string | ''>('');
  const level = ref<string>('');
  const semester = ref<number | ''>('');
  const search = ref<string>('');
  const isActive = ref<boolean | ''>('');

  // ✅ ADD THIS
  const currentPage = ref<number>(1);
  const itemsPerPage = ref<number>(50);

  const variables = computed(() => ({
    first: itemsPerPage.value,
    page: currentPage.value,
    filter: {
      programme_id: programmeId.value || undefined,
      course_registration_level: level.value || undefined,
      semester: semester.value === '' ? undefined : semester.value,
      query: search.value || undefined,
      is_active: isActive.value === '' ? undefined : isActive.value,
    },
  }));

  const { result, loading, refetch } = useListSchoolCurriculumsQuery(
    variables,
    { enabled: options?.autoFetch, fetchPolicy: 'cache-and-network' },
  );

  return {
    curriculum: computed(
      () => result.value?.listSchoolCurriculums?.data || [],
    ),
    paginatorInfo: computed(
      () => result.value?.listSchoolCurriculums?.paginatorInfo,
    ),
    loadingSchoolCurriculum: loading,

    // filters
    programmeId,
    level,
    semester,
    search,
    isActive,

    // ✅ pagination controls
    setPage: (page: number) => {
      currentPage.value = page;
    },
    setItemsPerPage: (count: number) => {
      itemsPerPage.value = count;
      currentPage.value = 1;
    },

    refetchSchoolCurriculum: refetch,
  };
}
